import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

type StateType = string | number | boolean;

@Injectable()
export class AppState {
  private state: Record<string, StateType> = {
    theme: 'default',
  };

  constructor(private readonly activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params?.theme) {
        this.set('theme', params.theme);
      }
    });
  }

  /**
   * Retrieve a property from the appState
   * @param prop Property key
   */
  get(prop?: string): StateType | null {
    const state = this.state;
    if (prop !== undefined && state[prop]) {
      return state[prop];
    } else {
      return null;
    }
  }

  /**
   * Update a property on the appState
   * @param prop Property key
   * @param value Property value
   */
  set(prop: string, value: StateType): StateType {
    this.state[prop] = value;

    return this.state[prop];
  }
}
